import { useState } from 'react'
import { Routes, Route, Link, useNavigate } from 'react-router-dom'
import Header from './components/Header'
import SearchBar from './components/SearchBar'
import SiteStatsBadge from './components/SiteStatsBadge'
import Login from './routes/login'
import Module1 from './routes/schools'
import Module2 from './routes/insights'
import Module3 from './routes/ai-volunteer'
import Module4 from './routes/hot-rankings'
import Announcements from './routes/announcements'
import About from './routes/about'
import AdminPanel from './components/AdminPanel'
import AdminUsers from './routes/admin-users'

export default function App() {
  return (
    <div style={{ minHeight: '100%' }}>
      <Header />
      <div className="ticker" role="status" aria-label="系统状态">
        <span><span className="dot-live" />系统运行中 · 2026-06-13 +08:00</span>
      </div>
      <main className="mx-auto max-w-5xl px-6 py-8">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/schools" element={<Module1 />} />
          <Route path="/insights" element={<Module2 />} />
          <Route path="/ai-volunteer" element={<Module3 />} />
          <Route path="/hot-rankings" element={<Module4 />} />
          <Route path="/announcements" element={<Announcements />} />
          <Route path="/about" element={<About />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <footer style={{ borderTop: '1px solid var(--rule)', textAlign: 'center', padding: '1.5rem', fontSize: 'var(--fs-capt)', color: 'var(--ink2)' }}>
        <div style={{ marginBottom: '.5rem' }}>
          <Link to="/announcements" className="no-underline" style={{ color: 'var(--ink2)', marginRight: '1rem' }}>最新公告</Link>
          <Link to="/about" className="no-underline" style={{ color: 'var(--ink2)', marginRight: '1rem' }}>关于我们</Link>
          <a href="mailto:support@boaoai.cn?subject=高考志愿填报助手%20试用申请" className="no-underline" style={{ color: 'var(--ink2)' }}>联系我们</a>
        </div>
        公开 · 免费 · 公益 — 高考志愿是个人决策,系统只供信息参考
      </footer>
    </div>
  )
}

function Home() {
  return (
    <div style={{ textAlign: 'center', paddingTop: '1.5rem' }}>
      <h1 className="serif" style={{ fontSize: 'var(--fs-h1)', fontWeight: 600, lineHeight: 1.15, margin: 0 }}>
        2026 陕西高考志愿助手
      </h1>
      <p style={{ marginTop: '.25rem', fontSize: 'var(--fs-body)', color: 'var(--ink2)' }}>
        公开 · 免费 · 公益
      </p>

      <SearchBar />

      <QuickAi />

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: '.5rem',
          marginTop: '2rem',
        }}
      >
        <MiniCard to="/schools" title="查院校" />
        <MiniCard to="/insights" title="看统计" />
        <MiniCard to="/ai-volunteer" title="AI 志愿" />
        <MiniCard to="/hot-rankings" title="热度" />
      </div>

      <SiteStatsBadge />

      <AdminPanel />
    </div>
  )
}

function QuickAi() {
  const [score, setScore] = useState('')
  const [rank, setRank] = useState('')
  const [c, setC] = useState<'物理类' | '历史类'>('物理类')
  const navigate = useNavigate()
  const canGo = score && !Number.isNaN(+score) && +score > 0 && rank && !Number.isNaN(+rank) && +rank > 0
  return (
    <div className="card" style={{ maxWidth: 520, margin: '1.5rem auto 0', padding: '1rem' }}>
      <div style={{ fontWeight: 600, fontSize: 'var(--fs-body)', marginBottom: '.5rem' }}>
        🤖 我考了 X 分,该填什么志愿?
      </div>
      <div className="flex flex-wrap items-end gap-2" style={{ justifyContent: 'center' }}>
        <label style={{ fontSize: 'var(--fs-capt)' }}>
          <div style={{ color: 'var(--ink3)', marginBottom: 2, textAlign: 'left' }}>分数</div>
          <input className="inp" type="number" value={score} onChange={e => setScore(e.target.value)} placeholder="如 580" style={{ width: 100 }} />
        </label>
        <label style={{ fontSize: 'var(--fs-capt)' }}>
          <div style={{ color: 'var(--ink3)', marginBottom: 2, textAlign: 'left' }}>位次</div>
          <input className="inp" type="number" value={rank} onChange={e => setRank(e.target.value)} placeholder="如 122026" style={{ width: 110 }} />
        </label>
        <label style={{ fontSize: 'var(--fs-capt)' }}>
          <div style={{ color: 'var(--ink3)', marginBottom: 2, textAlign: 'left' }}>科类</div>
          <select className="inp" value={c} onChange={e => setC(e.target.value as '物理类' | '历史类')}>
            <option value="物理类">物理类</option>
            <option value="历史类">历史类</option>
          </select>
        </label>
        <button
          onClick={() => navigate(`/ai-volunteer?score=${encodeURIComponent(score)}&curriculum=${encodeURIComponent(c)}&rank=${encodeURIComponent(rank)}`)}
          disabled={!canGo}
          className="btn-ink"
          style={{ fontSize: 'var(--fs-capt)', padding: '.4rem .85rem' }}
        >
          让 AI 帮我看 →
        </button>
      </div>
      <div style={{ marginTop: '.5rem', fontSize: 'var(--fs-capt)', color: 'var(--ink3)' }}>
        先填分和位次,看看 AI 给你的建议
      </div>
    </div>
  )
}

function MiniCard({ to, title }: { to: string; title: string }) {
  return (
    <Link
      to={to}
      className="btn-ghost no-underline"
      style={{ fontSize: 'var(--fs-capt)', padding: '.3rem .75rem', fontWeight: 500 }}
    >
      {title}
    </Link>
  )
}

function NotFound() {
  return (
    <div style={{ textAlign: 'center', padding: '3rem 1rem' }}>
      <h1 className="serif" style={{ fontSize: 'var(--fs-h1)', fontWeight: 600, margin: '0 0 .5rem' }}>404</h1>
      <p style={{ color: 'var(--ink2)', fontSize: 'var(--fs-body)', marginBottom: '1.5rem' }}>
        这页没了。可能是链接过期,可能是地址写错了。
      </p>
      <div className="flex justify-center gap-3" style={{ flexWrap: 'wrap' }}>
        <Link to="/" className="btn-ink no-underline">回首页</Link>
        <Link to="/announcements" className="btn-ghost no-underline">看最新公告</Link>
      </div>
    </div>
  )
}
